// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.O_0kWJI1Jo1P50dKrb_N {
  position: absolute;
  top: 30px;
  min-width: 30px;
  right: 0;
  font-family: 'Futura PT Cond';
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 5px 3px 3px;
  line-height: 0.7em;
  background: linear-gradient(180deg, #f82a00 -15%, #d31002 54.17%, #f82a00 123.33%);
  border: 0.5px solid #fa7400;
  /* #F9B901 - in Figma design */
  border-right: none;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  box-shadow: 1px 2px 2px 0px #00000059, 0px 0px 3.95px 1.58px #ba2002, inset 0px 0px 3.16px 0.79px #fc4000;
  clip-path: inset(-8px 0 -8px -8px);
  color: white;
  font-size: clamp(12px, 9cqi, 18px);
  font-weight: 700;
  letter-spacing: 0;
  text-align: center;
}
.E2zJdT6SSnXTj2EBf8_Q {
  background: linear-gradient(180deg, #0595fe -11.67%, #0383fe 51.19%, #0595fe 111.67%);
  border-color: #16d5ff;
  /* #28DFFF - in Figma design */
  box-shadow: 1px 2px 2px 0px #00000059, 0px 0px 3.16px 1.58px #006ae3, inset 0px 0px 3.16px 0.79px #06ccff;
}
@media (min-width: 1025px) {
  .O_0kWJI1Jo1P50dKrb_N {
    top: 38px;
    min-width: 38px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/games/components/GameCard/components/StatisticRtpGameBanner/StatisticRtpGameBanner.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,SAAS;EACT,eAAe;EACf,QAAQ;EACR,6BAA6B;EAC7B,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,wBAAwB;EACxB,kBAAkB;EAClB,kFAAkF;EAClF,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,8BAA8B;EAC9B,yGAAyG;EACzG,kCAAkC;EAClC,YAAY;EACZ,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,qFAAqF;EACrF,qBAAqB;EACrB,8BAA8B;EAC9B,yGAAyG;AAC3G;AACA;EACE;IACE,SAAS;IACT,eAAe;EACjB;AACF","sourcesContent":[".badge {\n  position: absolute;\n  top: 30px;\n  min-width: 30px;\n  right: 0;\n  font-family: 'Futura PT Cond';\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 5px 3px 3px;\n  line-height: 0.7em;\n  background: linear-gradient(180deg, #f82a00 -15%, #d31002 54.17%, #f82a00 123.33%);\n  border: 0.5px solid #fa7400;\n  /* #F9B901 - in Figma design */\n  border-right: none;\n  border-top-left-radius: 2px;\n  border-bottom-left-radius: 2px;\n  box-shadow: 1px 2px 2px 0px #00000059, 0px 0px 3.95px 1.58px #ba2002, inset 0px 0px 3.16px 0.79px #fc4000;\n  clip-path: inset(-8px 0 -8px -8px);\n  color: white;\n  font-size: clamp(12px, 9cqi, 18px);\n  font-weight: 700;\n  letter-spacing: 0;\n  text-align: center;\n}\n.coldTheme {\n  background: linear-gradient(180deg, #0595fe -11.67%, #0383fe 51.19%, #0595fe 111.67%);\n  border-color: #16d5ff;\n  /* #28DFFF - in Figma design */\n  box-shadow: 1px 2px 2px 0px #00000059, 0px 0px 3.16px 1.58px #006ae3, inset 0px 0px 3.16px 0.79px #06ccff;\n}\n@media (min-width: 1025px) {\n  .badge {\n    top: 38px;\n    min-width: 38px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badge": `O_0kWJI1Jo1P50dKrb_N`,
	"coldTheme": `E2zJdT6SSnXTj2EBf8_Q`
};
export default ___CSS_LOADER_EXPORT___;
